import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { RoleBasedFREActions, RoleBasedFREsLifecycle } from './types';

export const initialState: RoleBasedFREsLifecycle = {
  fulfilled: undefined,
  pending: false,
  rejected: undefined,
};

const reducer: Reducer<RoleBasedFREsLifecycle, RoleBasedFREActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'ROLE_BASED_FRE.TOGGLE_SETTINGS_TEACHING_BUBBLE': {
      return setFulfilled({
        ...state.fulfilled,
        showSettingsTeachingBubbleForRoleBasedFRE: action.payload.show,
      });
    }
    case 'ROLE_BASED_FRE.LOAD_TENANT_CONFIGURATION_AND_ROLES_PENDING': {
      return setPending();
    }
    case 'ROLE_BASED_FRE.LOAD_TENANT_CONFIGURATION_AND_ROLES_FULFILLED': {
      return setFulfilled({
        ...state.fulfilled,
        numberOfCorporateCommunicators: action.payload.numberOfCorporateCommunicators,
        allLeadersHaveAudience: action.payload.allLeadersHaveAudience,
        numberOfLeaders: action.payload.numberOfLeaders,
        viewerRoles: action.payload.viewerRoles,
      });
    }
    case 'ROLE_BASED_FRE.LOAD_TENANT_CONFIGURATION_AND_ROLES_REJECTED': {
      return setRejected(action.payload.error);
    }
    default:
      return state;
  }
};

export default reducer;
